<template>
    <div class="modal fade" id="modal-residents-peru">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{ __("messages.residents_peru") }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <span class="font-weight-bold">{{ __("messages.residents_peru") }}</span>
                    <p v-html="__('messages.detail_residents_peru')">
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btnPrimary btnPrimary--xs" data-dismiss="modal">{{ __("messages.close")
                    }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    methods: {

    }
}
</script>
